import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large' | 'xl';
  color?: 'primary' | 'secondary' | 'white' | 'dark';
  type?: 'spinner' | 'pulse' | 'dots' | 'ring' | 'bars';
  text?: string;
  overlay?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'medium',
  color = 'primary',
  type = 'spinner',
  text,
  overlay = false,
  className = '',
  style
}) => {
  const loaderClasses = [
    'universal-loader',
    `loader-${type}`,
    `loader-${size}`,
    `loader-${color}`,
    overlay ? 'loader-overlay' : '',
    className
  ].filter(Boolean).join(' ');

  const content = (
    <div className={loaderClasses} style={style}>
      <div className="loader-content">
        <div className="loader-animation">
          {type === 'spinner' && (
            <div className="spinner">
              <div className="spinner-circle"></div>
            </div>
          )}
          {type === 'pulse' && (
            <div className="pulse">
              <div className="pulse-dot"></div>
              <div className="pulse-dot"></div>
              <div className="pulse-dot"></div>
            </div>
          )}
          {type === 'dots' && (
            <div className="dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          )}
          {type === 'ring' && (
            <div className="ring">
              <div className="ring-circle"></div>
            </div>
          )}
          {type === 'bars' && (
            <div className="bars">
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
          )}
        </div>
        {text && <div className="loader-text">{text}</div>}
      </div>
    </div>
  );

  if (overlay) {
    return (
      <div className="loader-overlay-wrapper">
        {content}
      </div>
    );
  }

  return content;
};

export default Loader;